/**
 * Web Style Import
 *
 */

import './dnb-table.scss'
